module.exports = __webpack_public_path__ + "img/04.667035ec.png";